const paths = {
  arrow: 'M4 10h11M11 5l5 5-5 5',
  book: 'M4 4.5A1.5 1.5 0 0 1 5.5 3H16v14H5.5A1.5 1.5 0 0 0 4 18.5V4.5ZM16 3v14',
  check: 'M4 10.5 8 14.5 16 5.5',
  close: 'M5 5l10 10M15 5 5 15',
  copy: 'M7 7V4.5A1.5 1.5 0 0 1 8.5 3h7A1.5 1.5 0 0 1 17 4.5v7A1.5 1.5 0 0 1 15.5 13H13M3 8.5A1.5 1.5 0 0 1 4.5 7h7A1.5 1.5 0 0 1 13 8.5v7A1.5 1.5 0 0 1 11.5 17h-7A1.5 1.5 0 0 1 3 15.5v-7Z',
  download: 'M10 3v10m0 0 4-4m-4 4-4-4M3.5 16.5h13',
  github: 'M10 1.7a8.3 8.3 0 0 0-2.6 16.2c.4.1.6-.2.6-.5v-1.6c-2.3.5-2.8-1.1-2.8-1.1-.4-1-.9-1.2-.9-1.2-.8-.5 0-.5 0-.5.8.1 1.2.8 1.2.8.7 1.3 1.9.9 2.4.7.1-.5.3-.9.5-1.1-1.8-.2-3.8-.9-3.8-4.1 0-.9.3-1.7.8-2.3-.1-.2-.4-1 .1-2.1 0 0 .7-.2 2.3.9a7.7 7.7 0 0 1 4.2 0c1.6-1.1 2.3-.9 2.3-.9.5 1.1.2 1.9.1 2.1.5.6.8 1.4.8 2.3 0 3.2-2 3.9-3.8 4.1.3.3.6.8.6 1.6v2.4c0 .3.2.6.6.5A8.3 8.3 0 0 0 10 1.7Z',
  menu: 'M3 6h14M3 10h14M3 14h14',
  moon: 'M16 11.5A6.5 6.5 0 0 1 8.5 4a6.5 6.5 0 1 0 7.5 7.5Z',
  search: 'M12.5 12.5 17 17M14 9a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z',
  sidebar: 'M3.5 4.5h13v11h-13v-11ZM8 4.5v11',
  sun: 'M10 3.5v1.5M10 15v1.5M3.5 10H5m10 0h1.5M5.4 5.4l1 1m7.2 7.2 1 1m0-9.2-1 1m-7.2 7.2-1 1M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  sun_: '',
  translate: 'M3 5h7M6.5 5v1.5c0 3-1.5 5-3.5 6M5 9.5c.7 1.7 2.2 3 4 3.5M10.5 17l3.2-8 3.3 8M11.9 14.2h4.3'
}

export default function Icon({ name, size = 18, ...rest }) {
  const d = paths[name]
  if (!d) return null

  return (
    <svg
      aria-hidden="true"
      fill="none"
      height={size}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.6"
      viewBox="0 0 20 20"
      width={size}
      {...rest}
    >
      <path d={d} />
    </svg>
  )
}
